import { isPlatformServer } from '@angular/common';
import { OnChanges, Directive, SimpleChanges } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl, Validators, ValidatorFn } from '@angular/forms';

declare var require: any;

export function validateIban(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control) {
      const ibanCtrl: AbstractControl = control.get('iban');
      if (ibanCtrl && ibanCtrl.value) {
        const isValid: boolean = isValidIBANNumber(ibanCtrl.value);
        if (!isValid) {
          ibanCtrl.setErrors({ 'ibanValidation': true });
        }
      }
    }

    // return isValid ? null : { 'ibanValidation': true };
    return null;
  };
}

function isValidIBANNumber(input: string): boolean {
  if (input == null) {
    return false;
  }

  const CODE_LENGTHS = {
    AL: 28, DZ: 24, AD: 24, AO: 25, AT: 20, AZ: 28, BH: 22, BY: 28, BE: 16, BJ: 28,
    BA: 20, BR: 29, VG: 24, BG: 22, BF: 27, BI: 16, CM: 27, CV: 25, FR: 27, CG: 27,
    CR: 21, HR: 21, CY: 28, CZ: 24, DK: 18, DO: 28, EG: 27, EE: 20, FO: 18, FI: 18,
    GA: 27, GE: 22, DE: 22, GI: 23, GR: 27, GL: 18, GT: 28, GG: 22, HU: 28, IS: 26,
    IR: 26, IQ: 23, IE: 22, IM: 22, IL: 23, IT: 27, CI: 28, JE: 22, JO: 30, KZ: 20,
    XK: 20, KW: 30, LV: 21, LB: 28, LI: 21, LT: 20, LU: 20, MK: 19, MG: 27, ML: 28,
    MT: 31, MR: 27, MU: 30, MD: 24, MC: 27, ME: 22, MZ: 25, NL: 18, NO: 15, PK: 24,
    PS: 29, PL: 28, PT: 25, QA: 29, RO: 24, LC: 32, SM: 27, ST: 25, SA: 24, SN: 28,
    RS: 22, SC: 31, SK: 24, SI: 19, ES: 24, SE: 24, CH: 21, TL: 23, TN: 24, TR: 26,
    UA: 29, AE: 23, GB: 22,
  };

  let iban = input.toUpperCase().replace(/[^A-Z0-9]/g, ''),
    code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),
    digits;

  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
    return false;
  }

  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter) => {
    return (letter.charCodeAt(0) - 55).toString();
  });

  return mod97(digits) === 1;
}

function mod97(input: string): number {
  let checksum: any = input.slice(0, 2), fragment;

  for (let offset = 2; offset < input.length; offset += 7) {
    fragment = checksum + input.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }

  return checksum; // should be 1 for valid IBAN
}

@Directive({
  selector: '[validIban]',
  providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }]
})
export class IbanValidatorDirective implements Validator, OnChanges {
  private valFn = Validators.nullValidator;

  private publicKey: string;

  constructor() {
    this.valFn = validateIban();
  }

  validate(control: AbstractControl): { [key: string]: any; } {
    return this.valFn(control);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.valFn = validateIban();
  }

  registerOnValidatorChange(fn: () => void): void {
    // TODO Auto-generated method stub
    return;
  }

}